'use memo';

import Icon from '@/components/Icon/Icon';
import { HStack, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { BentoCard } from './BentoCard';
type FactorRow = {
  label: string;
  value: number;
};
function ScoreRing() {
  return <div className="relative size-[88px] shrink-0">
      <div className="size-full rounded-full" style={{
      background: 'conic-gradient(var(--color-slate-600) 0% 72%, var(--neutral-muted-fill) 72% 100%)'
    }} />
      <div className="absolute inset-[10px] grid place-items-center rounded-full bg-neutral-fill">
        <Text as="p" className="font-mono text-2xl font-bold leading-none tabular-nums">
          72
        </Text>
        <Text variant="labelSmallReg" className="text-neutral-muted-on-fill">
          / 100
        </Text>
      </div>
    </div>;
}
function FactorBars({
  rows
}: {
  rows: FactorRow[];
}) {
  return <div className="flex flex-col gap-2">
      {rows.map(row => <div key={row.label} className="flex items-center gap-2.5 text-pSmall">
          <div className="w-24 shrink-0 text-neutral-muted-on-fill">
            {row.label}
          </div>
          <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-neutral-muted-fill">
            <div className="h-full rounded-full bg-slate-400" style={{
          width: `${row.value}%`
        }} />
          </div>
          <div className="w-6 shrink-0 text-right font-mono font-bold tabular-nums">
            {row.value}
          </div>
        </div>)}
    </div>;
}

/** カード7: アクセス統制スコア（Coming soon）。算出ロジック未実装のためプレビューを淡色表示。 */
export function GovernanceScoreCard() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.accesses.overview.bento.governanceScore'
  });
  const {
    t: tBento
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.accesses.overview.bento'
  });
  const factors: FactorRow[] = [{
    label: t('factorClassification'),
    value: 82
  }, {
    label: t('factorShadow'),
    value: 58
  }, {
    label: t('factorDormancy'),
    value: 64
  }, {
    label: t('factorPermission'),
    value: 75
  }];
  return <BentoCard title={t('title')}>
      <div className="relative mt-3 h-[200px] overflow-hidden rounded-md">
        {/* プレビュー（非稼働）。ブラーをかけて中央の Coming soon を主役にする */}
        <div className="pointer-events-none absolute inset-0 select-none blur-[3px]">
          <div className="grid h-full grid-cols-1 content-center items-center gap-5 lg:grid-cols-[240px_1fr_1fr]">
            <HStack className="items-center gap-4">
              <ScoreRing />
              <VStack className="gap-1">
                <Text variant="pBold">{t('grade')}</Text>
              </VStack>
            </HStack>

            <VStack className="gap-2.5 lg:border-l lg:border-neutral-muted-fill lg:pl-5">
              <Text variant="labelSmall" className="text-neutral-muted-on-fill">
                {t('breakdownTitle')}
              </Text>
              <FactorBars rows={factors} />
            </VStack>

            <VStack className="gap-2.5 lg:border-l lg:border-neutral-muted-fill lg:pl-5">
              <Text variant="labelSmall" className="text-neutral-muted-on-fill">
                {t('topImprovementTitle')}
              </Text>
              <VStack className="gap-1.5 rounded-md bg-neutral-muted-fill p-3">
                <div className="h-2 w-4/5 rounded-full bg-slate-400/50" />
                <div className="h-2 w-3/5 rounded-full bg-slate-400/50" />
              </VStack>
            </VStack>
          </div>
        </div>

        {/* 薄い白オーバーレイでブラーをさらに馴染ませる */}
        <div className="absolute inset-0 bg-neutral-fill/40" />

        {/* Coming soon（添付の従業員の動向に平仄を合わせ、ロケット＋テキストのみ） */}
        <VStack className="absolute inset-0 items-center justify-center gap-2 text-center">
          <Icon iconName="RocketIcon" className="h-9 w-9 text-neutral-on-fill" />
          <Text variant="h3" as="h3" className="capitalize leading-7">
            {tBento('comingSoon')}
          </Text>
        </VStack>
      </div>
    </BentoCard>;
}